import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { confirmPasswordReset } from "../services/authService";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token) {
      setStatus("Chybí resetovací token.");
      return;
    }
    setSaving(true);
    setStatus("");
    try {
      await confirmPasswordReset({ token, password });
      setStatus("Heslo bylo změněno. Nyní se můžete přihlásit.");
      setPassword("");
    } catch (err) {
      setStatus(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="invite-gate">
      <h2>Obnova hesla</h2>
      <p>Vložte nové heslo k vašemu účtu.</p>
      <form className="profile-form" onSubmit={handleSubmit}>
        <label>
          Nové heslo
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Min. 8 znaků"
            required
          />
        </label>
        <button className="site-button site-button--primary" type="submit" disabled={saving}>
          {saving ? "Ukládám..." : "Nastavit nové heslo"}
        </button>
        {status && <span className="auth-modal__hint">{status}</span>}
      </form>
      <Link to="/" className="invite-gate__link">
        Zpět na úvod
      </Link>
    </main>
  );
}

export default ResetPasswordPage;
